import React from 'react'
import enumMapper from '../enumMapper';

const InitialPlanFooter = ({ planInfo, countTreeBed, countTwoBed, countFourBed }) => {
    const ModirRoohaniRoomNumbers = {}
    for (let index = 0; index < planInfo?.floors.length; index++) {
        const floor = planInfo?.floors[index];
        for (let index = 0; index < floor.rooms.length; index++) {
            const room = floor.rooms[index];

            if (room.roomType === enumMapper.RoomType.Themanagerandclergyofthecaravans) {
                ModirRoohaniRoomNumbers.Themanagerandclergyofthecaravans = room?.roomNumber;
            }
            if (room.roomType === enumMapper.RoomType.DeputyManagers) {
                ModirRoohaniRoomNumbers.DeputyManagers = room?.roomNumber;
            }
            if (room.roomType === enumMapper.RoomType.clergyOfTwoPlans) {
                ModirRoohaniRoomNumbers.clergyOfTwoPlans = room?.roomNumber;
            }
            if (room.roomType === enumMapper.RoomType.Managers) {
                ModirRoohaniRoomNumbers.Managers = room?.roomNumber;
            }
            if (room.roomType === enumMapper.RoomType.clergy) {
                ModirRoohaniRoomNumbers.clergy = room?.roomNumber;
            }
            if (room.roomType === enumMapper.RoomType.clergyAndMoeen) {
                ModirRoohaniRoomNumbers.clergyAndMoeen = room?.roomNumber
            }

            if (room.roomType === enumMapper.RoomType.ManagerCleric) {
                ModirRoohaniRoomNumbers.ManagerCleric = room?.roomNumber
            }
            if (room.roomType === enumMapper.RoomType.ManagersOfTwoPlans) {
                ModirRoohaniRoomNumbers.ManagersOfTwoPlans = room?.roomNumber
            }
            if (room.roomType === enumMapper.RoomType.DirectorDeputyCleric) {
                ModirRoohaniRoomNumbers.DirectorDeputyCleric = room?.roomNumber
            }
            if (room.roomType === enumMapper.RoomType.FixedManager) {
                ModirRoohaniRoomNumbers.FixedManager = room?.roomNumber
            }


            //  //مدیر و روحانی
            //     ManagerCleric:36,
            //     //مدیران دو پلان
            //     ManagersOfTwoPlans:37,
            //     //مدیر، معاون و روحانی
            //     DirectorDeputyCleric:38,
            //     //مدیر ثابت
            //     FixedManager:39,

        }
    }



    return (
        <table cellSpacing={0} className='innertable'>
            <tbody>
                <tr>
                    <th style={{ width: '100px' }}>تعداد تخت </th>
                    <td style={{ width: '100px' }}>{
                        planInfo && (countTreeBed * 3) + (countTwoBed * 2) + (countFourBed * 4)
                    }
                    </td>
                    <th style={{ width: '100px' }}>اتاق 2 تخته </th>
                    <td style={{ width: '70px' }}>{countTwoBed} </td>
                    <th style={{ width: '100px' }}>اتاق 3 تخته</th>
                    <td style={{ width: '70px' }}>{countTreeBed} </td>
                    {
                        countFourBed > 0 && <>
                            <th style={{ width: '100px' }}>اتاق 4 تخته</th>
                            <td style={{ width: '70px' }}>{countFourBed} </td>
                        </>
                    }
                    {
                        ModirRoohaniRoomNumbers?.Themanagerandclergyofthecaravans && (<><th style={{ width: '310px' }}> شماره اتاق روحانی و مدیر محترم کاروان </th>
                            <td style={{ width: '70px' }}>{ModirRoohaniRoomNumbers?.Themanagerandclergyofthecaravans}</td></>)
                    }
                    {
                        ModirRoohaniRoomNumbers?.DeputyManagers && (<><th style={{ width: '150px' }}>اتاق مدیر و معاون</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.DeputyManagers
                            }</td></>)
                    }
                    {
                        ModirRoohaniRoomNumbers?.clergyOfTwoPlans && (<><th style={{ width: '150px' }}>اتاق روحانی دو پلان</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.clergyOfTwoPlans
                            }</td></>)
                    }
                    {
                        ModirRoohaniRoomNumbers?.Managers && (<><th style={{ width: '100px' }}>اتاق مدیران</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.Managers
                            }</td></>)
                    }
                    {
                        ModirRoohaniRoomNumbers?.clergy && (<><th style={{ width: '100px' }}>اتاق روحانیون</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.clergy
                            }</td></>)
                    }
                    {
                        ModirRoohaniRoomNumbers?.clergyAndMoeen && (<><th style={{ width: '135px' }}>اتاق روحانی با معین</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.clergyAndMoeen
                            }</td></>)
                    }

                    {
                        ModirRoohaniRoomNumbers?.ManagerCleric && (<><th style={{ width: '135px' }}>اتاق مدیر و روحانی</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.ManagerCleric
                            }</td></>)
                    }

                    {
                        ModirRoohaniRoomNumbers?.ManagersOfTwoPlans && (<><th style={{ width: '135px' }}>اتاق مدیران دو پلان</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.ManagersOfTwoPlans
                            }</td></>)
                    }

                    {
                        ModirRoohaniRoomNumbers?.DirectorDeputyCleric && (<><th style={{ width: '135px' }}>اتاق مدیر، معاون و روحانی</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.DirectorDeputyCleric
                            }</td></>)
                    }

                    {
                        ModirRoohaniRoomNumbers?.FixedManager && (<><th style={{ width: '135px' }}>اتاق مدیر ثابت</th>
                            <td style={{ width: '70px' }}>{
                                ModirRoohaniRoomNumbers?.FixedManager
                            }</td></>)
                    }


                </tr>
            </tbody>
        </table>
    )
}

export default InitialPlanFooter